import { TextFieldUI, TextFieldUIProps } from '../TextField/TextFieldUI';

// TODO: type=email instead of parent trim
export const EmailFieldUI = <Fields extends object>(
  props: TextFieldUIProps<Fields>
) => <TextFieldUI<Fields> {...props} />;
